<template>
  <div class="sp-container" :class="modifierClasses">
    <slot class="slot" />
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useBreakpoints } from "#ce/composables/useBreakpoints";
import { toBoolean, toCssUnit } from "#ce/utils/props";
import { container as componentProps } from "./props";

const props = defineProps(componentProps);

const { breakpointModifiers } = useBreakpoints();

const modifierClasses = computed(() => [
  ...breakpointModifiers.value,
  {
    "--flex": toBoolean(props.flex),
    [`--direction-${props.direction}`]: props.direction,
    [`--direction-sm-${props.directionSm}`]: props.directionSm,
  },
]);

const rowGap = computed(() => toCssUnit(props.rowgap));
const rowGapSm = computed(() => toCssUnit(props.rowgapSm ?? props.rowgap));
const columnGap = computed(() => toCssUnit(props.columngap));
const columnGapSm = computed(() => toCssUnit(props.columngapSm ?? props.columngap));
</script>

<style>
:host {
  display: block;
  width: 100%;
}
</style>

<style scoped lang="scss">
.sp-container {
  &.--flex {
    --direction: v-bind(direction);
    --direction-sm: v-bind(directionSm);
    --row-gap: v-bind(rowGap);
    --row-gap-sm: v-bind(rowGapSm);
    --column-gap: v-bind(columnGap);
    --column-gap-sm: v-bind(columnGapSm);
    --flex-wrap: v-bind(flexWrap);
    --align-items-prop: v-bind(alignItems);
    --align-items: var(--sp-comp-container-align-items, var(--align-items-prop));
    --justify-content-prop: v-bind(justifyContent);
    --justify-content: var(--sp-comp-container-justify-content, var(--justify-content-prop));

    .slot {
      display: flex;
      flex-direction: var(--direction);
      width: 100%;
      row-gap: var(--row-gap);
      column-gap: var(--column-gap);
      flex-wrap: var(--flex-wrap);
      align-items: var(--align-items);
      justify-content: var(--justify-content);
    }

    &.--direction-column,
    &.--is-sm-screen.--direction-sm-column {
      ::slotted(*) {
        width: var(--sp-comp-container-column-width, 100%);
      }
    }

    &.--is-sm-screen {
      --direction: var(--direction-sm);
      --row-gap: var(--row-gap-sm);
      --column-gap: var(--column-gap-sm);
    }
  }
}
</style>
